import { render, staticRenderFns } from "./disabilitycardReview.vue?vue&type=template&id=27e6849a&scoped=true&"
import script from "./disabilitycardReview.vue?vue&type=script&lang=js&"
export * from "./disabilitycardReview.vue?vue&type=script&lang=js&"
import style0 from "./disabilitycardReview.vue?vue&type=style&index=0&id=27e6849a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e6849a",
  null
  
)

export default component.exports